/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_CheckinInputs */



/**
* | output |
* | --- |
* | "Check-in" |
*
* @param {State_CheckinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const state_checkin = /** @type {((inputs?: State_CheckinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_CheckinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check-in")
	return /** @type {LocalizedString} */ ("Check-in")
});